import { useQuery } from '@tanstack/react-query';

import type { SalesAnalysisReport } from '../types/report';

const BASE_URL = 'https://ai-db.dalock.kr/Libra';

const fetchReport = async (filename: string): Promise<SalesAnalysisReport> => {
  const response = await fetch(`${BASE_URL}/${filename}`);
  if (!response.ok) {
    throw new Error('리포트 데이터를 불러오는데 실패했습니다.');
  }
  return response.json();
};

export const useReport = (filename: string | null) => {
  return useQuery({
    queryKey: ['report', filename],
    queryFn: () => fetchReport(filename!),
    enabled: !!filename,
  });
};
